import tracker from 'src/api/tracker';

const sendEventClick = ({ section, position }) => {
  tracker('send', 'eventclick', { section, position });
};

export default sendEventClick;
